<template>
    <v-hover v-slot="{ hover }" open-delay="200" >
        <div class="app-side-buttons">
            <v-scale-transition>
                <div v-show="hover || permanent">
                    <c-menu-button
                        label      = "inc.overview.menu.export"
                        icon       = "mdi-download"
                        icon-color = "primary--text"
                        @click     = "onDownload"
                    />

                    <c-menu-button
                        label      = "inc.overview.menu.refresh"
                        icon       = "mdi-refresh"
                        icon-color = "primary--text"
                        @click     = "onRefresh"
                    />
                </div>
           </v-scale-transition>
        </div>
    </v-hover>
</template>

<script>

import CMenuButton from "@/modules/core/components/utils/CMenuButton";

export default {
    name: "MSiteOverviewMenu",

    components: {
        CMenuButton
    },

    props: {
        ignoreDeleted: {
            required: false,
            type: Boolean,
            default: function () {
                return null;
            }
        }
    },

    data: () => ({
        deleted : false
    }),

    mounted() {
        this.deleted = this.ignoreDeleted;
    },

    computed: {
        permanent () {
            if (!this.preferences) {
                return false;
            }

            return this.preferences["permanentMenu"];
        },

        preferences () {
            return this.$store.getters.preferences;
        },
    },

    methods: {
        onIgnoreDeleted () {
            this.deleted = !this.deleted;
            this.$emit("ignore-deleted", this.deleted);
        },

        onDownload () {
            this.$emit("download");
        },

        onRefresh () {
            this.$emit("refresh");
        },
    }
}
</script>
